// Sellers with 7-day delivery from USA
const CL_INTERNATIONAL_DELIVERY_7_DAYS_USA = [
  'SC95603',
  'SC551F4',
  'SC7F57B',
  'SC4F985',
  'SC578B2',
  'SC672CE',
  'SCB3C34',
  'SCCB933',
  'SCC264B',
  'SC674C4',
  'SC8AA4A',
  'SCDC8EB',
  'SCB8BBD',
  'SC2AF79',
  'SC9704C',
  'SCE063A',
  'SCB6B5C',
];

// Sellers shipping from USA (general)
const CL_INTERNATIONAL_DELIVERY_FROM_USA = [
  'SCEAE9B',
  'SC86454',
  'SC73D48',
  'SC61FD0',
  'SC09944',
  'SC12039',
  'SCF841F',
  'SC82726',
  'SC22263',
  'SC04221',
  'SCBDB27',
  'SCD2029',
  'SC3A732',
  'SC7EFFB',
  'SC46EB6',
  'SCD7125',
  'SC8691B',
  'SCC87B7',
];

// Sellers with general international delivery
const CL_INTERNATIONAL_DELIVERY = [
  'SCE6504',
  'SC85E11',
  'SCFFFFA',
  'SCB6552',
  'SC56407',
  'SC7E2DD',
  'SC442FA',
  'SC4ECDB',
  'SC79C72',
  'SC1F96D',
  'SC75F84',
  'SC16904',
  'SC93617',
  'SC80413',
  'SC2293E',
  'SC24F00',
  'SC0CDED',
  'SC93BFA',
  'SC0FFAD',
  'SCC88B8',
  'SCA2E40',
  'SC37DF4',
  'SC84D9F',
  'SC52B4A',
  'SC803E1',
  'SC4F3CC',
  'SC3A7BF',
  'SC1C88B',
  'SC63D61',
  'SCA26B6',
  'SC5002C',
  'SCB4CE2',
  'SC37E82',
  'SCAA017',
  'SC66819',
  'SC5DB31',
  'SC66C67',
  'SCF1B97',
  'SC46619',
  'SCC1049',
  'SC19BE3',
  'SCCF2F3',
  'SC883AA',
  'SC6C7BF',
  'SC08B62',
  'SCF760D',
  'SC75F84',
  'SCAC01B',
  'SCBF9BA',
  'SC1F96D',
  'SCFA043',
  'SCC921A',
  'SCF106D',
  'SC3AA44',
  'SC6B3E9',
  'SC80413',
  'SC06EE9',
  'SC1CDE9',
  'SC93BFA',
  'SCC88B8',
  'SC2293E',
  'SC70165',
  'SC071B6',
  'SCF6323',
  'SC43858',
  'SCC3FDF',
  'SCB0FC2',
  'SCA2E40',
  'SC8A08C',
  'SC943C1',
  'SCC8633',
  'SCF91F0',
  'SC46B57',
  'SC7E407',
  'SC2A133',
  'SC07098',
  'SC4DD3C',
  'SCD8A8D',
  'SC5338A',
  'SC5002C',
  'SC63D61',
  'SCAF821',
  'SC652D3',
  'SCFD4FC',
  'SC6407B',
  'SCDCE81',
  'SC59EA1',
  'SC044FD',
  'SCB5497',
  'SC467E3',
  'SC13B62',
  'SCA6FFB',
  'SC172A7',
  'SC2B864',
  'SC7EFC2',
  'SC46758',
  'SCCBEDB',
  'SC17F55',
  'SC62798',
  'SC17D0A',
  'SCB6DA5',
  'SC8F5DF',
  'SC46B57',
  'SCF0D92',
  'SCD8A8D',
  'SC7DE71',
  'SC1C88B',
  'SC84D9F',
  'SC3AECB',
  'SC94F38',
  'SC4F3CC',
  'SC5DB31',
  'SC7793E',
  'SC66C67',
  'SC7E2DD',
  'SC08B62',
  'SC37DF4',
  'SC442FA',
  'SCFFFFA',
];

const PE_INTERNATIONAL_DELIVERY_7_DAYS_USA = [
  'SCB3403',
  'SCA3D2D',
  'SCD0ECB',
  'SC62EB0',
  'SC3C467',
  'SC7CC61',
  'SCADDD9',
  'SC4BD02',
  'SCFECAB',
];

const PE_INTERNATIONAL_DELIVERY_FROM_USA = [
  'SC6D878',
  'SC01DF8',
  'SCE4EF8',
  'SC6AA99',
  'SC50D77',
  'SC9FA9A',
  'SCD1640',
  'SC7717A',
  'SC7EFFB',
  'SC8C480',
  'SC27B00',
  'SC2E873',
  'SCFAC9A',
  'SC2164A',
  'SC95BC3',
  'SC72C50',
  'SC3F294',
  'SC6ECBA',
  'SC58BEB',
  'SC45559',
  'SC8CE29',
  'SCB7BC4',
  'SCE24B7',
  'SCF30E0',
  'SC73D48',
  'SCF1777',
  'SCC7772',
  'SC632DF',
];

const PE_INTERNATIONAL_DELIVERY = [
  'SCEE718',
  'SC366E6',
  'SCD84DE',
  'SCCF9F0',
  'SC3E4D1',
  'SC1849F',
  'SCC2BBA',
  'SC0466B',
  'SC97911',
  'SCE1874',
  'SC95A80',
  'SC5D058',
  'SC41FFD',
  'SCF6D8E',
  'SCD93A5',
  'SC80F90',
  'SC61918',
  'SC17D83',
  'SC345D0',
  'SC52916',
  'SC8DB9B',
  'SCB9A8E',
  'SC7A1EF',
  'SCF1663',
  'SC469ED',
  'SC0F6D2',
  'SC85AFE',
  'SC0C70F',
  'SC13753',
  'SC97B7B',
  'SC4833D',
  'SC98552',
  'SCFA99B',
  'SC8F0A3',
  'SC01E5A',
  'SC3F418',
  'SCEFEF2',
  'SC935E1',
  'SC6178A',
  'SCC1049',
  'SCAF80D',
  'SCA99AB',
  'SC78739',
  'SC706AB',
  'SC68431',
  'SC25247',
  'SC96A7C',
  'SCD0E2D',
  'SC00871',
  'SC9714B',
  'SC8EC3A',
  'SCCFCAF',
  'SC26C0D',
  'SC588C3',
  'SC46F4A',
  'SC9DEDF',
  'SC4A572',
  'SC2798A',
  'SCE4E0A',
  'SCAEED6',
  'SCA56AA',
  'SCE9D66',
  'SC830D1',
  'SC6CE52',
  'SC91025',
  'SC6CA96',
  'SC3E2F9',
  'SC2FCAF',
  'SC089FD',
  'SC6E00B',
  'SCD079B',
  'SCEC20F',
  'SC360AD',
  'SCED432',
  'SC581DB',
  'SC88F87',
  'SCC6864',
  'SCF2066',
  'SCF7665',
  'SC808FF',
  'SC5EC52',
  'SCE6824',
  'SCBE97B',
  'SC00E65',
  'SCBFAD2',
  'SCAAB17',
  'SC0DA1F',
  'SC62AED',
  'SC62AED',
];

const INTERNATIONAL_DELIVERY_7_DAYS_USA = [
  ...CL_INTERNATIONAL_DELIVERY_7_DAYS_USA,
  ...PE_INTERNATIONAL_DELIVERY_7_DAYS_USA,
];
const INTERNATIONAL_DELIVERY_FROM_USA = [...CL_INTERNATIONAL_DELIVERY_FROM_USA, ...PE_INTERNATIONAL_DELIVERY_FROM_USA];
const INTERNATIONAL_DELIVERY = [...CL_INTERNATIONAL_DELIVERY, ...PE_INTERNATIONAL_DELIVERY];

// Seller type detection functions
export const isSevenDayUSASeller = (sellerId) => INTERNATIONAL_DELIVERY_7_DAYS_USA.includes(sellerId);
export const isUSASeller = (sellerId) => INTERNATIONAL_DELIVERY_FROM_USA.includes(sellerId);
export const isInternationalSeller = (sellerId) => INTERNATIONAL_DELIVERY.includes(sellerId);

// Message configuration based on seller type
export const INTERNATIONAL_SHIPPING_MESSAGES = {
  INTERNATIONAL_DELIVERY_7_DAYS_USA: 'Envío desde EEUU, llega en 7 días.',
  INTERNATIONAL_DELIVERY_FROM_USA: 'Envío desde EEUU.',
  INTERNATIONAL_DELIVERY: 'Envío Internacional.',
};

export const getSellerType = (sellerId, applicable) => {
  if (isSevenDayUSASeller(sellerId)) {
    return 'INTERNATIONAL_DELIVERY_7_DAYS_USA';
  }
  if (isUSASeller(sellerId)) {
    return 'INTERNATIONAL_DELIVERY_FROM_USA';
  }
  if (isInternationalSeller(sellerId) || applicable) {
    return 'INTERNATIONAL_DELIVERY';
  }

  return null;
};

export { INTERNATIONAL_DELIVERY, INTERNATIONAL_DELIVERY_7_DAYS_USA, INTERNATIONAL_DELIVERY_FROM_USA };
